type Game6Map = {
  intro: string[]
  animals: Array<{
    id: string
    label: string
    img: string
  }>
}

export const Game6Map: Game6Map = {
  intro: ['Poznáš zvířata, která můžeš potkat v lese?', 'Přetáhni názvy ke správným obrázkům'],
  animals: [
    { id: 'a', label: 'Chrobák lesní', img: require('../assets/game6/a_chrobak_lesni-min.jpg').default },
    { id: 'b1', label: 'Jelen lesní', img: require('../assets/game6/b1_jelen_lesni-min.jpg').default },
    { id: 'b2', label: 'jelen evropský (samice)', img: require('../assets/game6/b2_lan-min.jpg').default },
    { id: 'c', label: 'Bekyně mniška', img: require('../assets/game6/c_bekyne_mniska-min.jpg').default },
    { id: 'd', label: 'Lýkožrout smrkový', img: require('../assets/game6/d_lykozrout_smrkovy-min.jpg').default },
    { id: 'e', label: 'Ještěrka obecná', img: require('../assets/game6/e_jesterka_obecna-min.jpg').default },
    { id: 'f', label: 'Zmije obecná', img: require('../assets/game6/f_zmije_obecna-min.jpg').default },
    { id: 'g', label: 'Brhlík lesní', img: require('../assets/game6/g_brhlik_lesni-min.jpg').default },
    { id: 'i', label: 'Jestřáb lesní', img: require('../assets/game6/i_jestrab_lesni-min.jpg').default },
    { id: 'j', label: 'Sova pálená', img: require('../assets/game6/j_sova_palena-min.jpg').default },
    { id: 'k1', label: 'Srnec obecný', img: require('../assets/game6/k1_srnec_obecny-min.jpg').default },
    { id: 'k2', label: 'Srnec obecný (samice)', img: require('../assets/game6/k2_srna-min.jpg').default },
    { id: 'l1', label: 'Daněk skvrnitý', img: require('../assets/game6/l1_danek_skvrnity-min.jpg').default },
    { id: 'l2', label: 'Daněk skvrnitý (samice)', img: require('../assets/game6/l2_danek_skvrnity-min.jpg').default },
    { id: 'm', label: 'Prase divoké', img: require('../assets/game6/m_prase_divoke-min.jpg').default },
    { id: 'n', label: 'Liška obecná', img: require('../assets/game6/n_liska_obecna-min.jpg').default },
    { id: 'o', label: 'Veverka obecná', img: require('../assets/game6/o_veverka_obecna-min.jpg').default },
    { id: 'p', label: 'Zajíc polní', img: require('../assets/game6/p_zajic_polni-min.jpg').default },
  ],
}
